import { Injectable } from '@angular/core';
import { TaskTable } from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class TaskService {
	constructor() {}

	filterDeletableTasks(taskList: Array<TaskTable>, userId: number): Array<TaskTable> {
		return taskList.filter((task) => this.isTaskDeletable(task, userId));
	}

	getDeleteWarningMessage(undeletedTasks: number, selectedTasks: number): string {
		return `Can not delete ${undeletedTasks} out of ${selectedTasks} task(s) created by other user.`;
	}

	isTaskDeletable(task: TaskTable, userId: number): boolean {
		return task.createdById == userId;
	}

	isTaskNotDeletable(task: TaskTable, userId: number): boolean {
		return !this.isTaskDeletable(task, userId);
	}
}
